<div>
    <button mat-button>{{name}}</button>
    <ng-content></ng-content>
</div>